// extracted by mini-css-extract-plugin
export var locationCard = "_qs-0";